import { render } from "./ExorciseModal.vue?vue&type=template&id=027b728d&scoped=true"
import script from "./ExorciseModal.vue?vue&type=script&lang=js"
export * from "./ExorciseModal.vue?vue&type=script&lang=js"

import "./ExorciseModal.vue?vue&type=style&index=0&id=027b728d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027b728d"]])

export default __exports__